module.exports = __webpack_public_path__ + "img/UTPIUT-7.867f0b6e.jpg";